import { SignService } from '@common/SignService';

const SUPPLEMENTAL_WAIVER__KEY = 'supplemental_waiver';

export const supplementalWaiverService = new SignService(SUPPLEMENTAL_WAIVER__KEY);
